import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=c95a871e&scoped=true&"
import script from "./StoreDetail.vue?vue&type=script&lang=js&"
export * from "./StoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=c95a871e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95a871e",
  null
  
)

export default component.exports